import React from 'react';

class PackageFeatures extends React.Component {

  constructor(props) {
    super(props);
  }

  _featuresToRender() {

	const featureList = this.props.featureList

	const featuresToRender = []
        
	featureList.map((item) => {
		featuresToRender.push((<li className="col-xs-12 col-sm-4 col-md-6 col-lg-4" key={item}>{item}</li>))
	})

	return featuresToRender

  }

  _hasFeatures() {

	return (this.props.featureList == undefined || this.props.featureList.length < 1) ? false : true;

  }

  render() {

	var a = this;

	var searchingClass = a._hasFeatures() ? 'd-none' : '';

    return (

			<div>

					<div className={'row ' + searchingClass}>
						<div className="'col-xs-12 text-center">
							<p>Gathering package features <img className="spinner" src="/content/images/loading.gif" height="30" width="30" alt="Gathering package features" /></p>
						</div>
					</div>
					
					<div className="featureSet">
						<ul className="row">
							{a._featuresToRender()}
						</ul>
					</div>

			</div>

    );
  }
};

export default PackageFeatures;



// WEBPACK FOOTER //
// ./Scripts/App/Hosting/Components/PackageFeatures.es6